import { render, staticRenderFns } from "./progressDtu.vue?vue&type=template&id=4ae86b0e&scoped=true"
import script from "./progressDtu.vue?vue&type=script&lang=js"
export * from "./progressDtu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae86b0e",
  null
  
)

export default component.exports